import React from 'react';
import { SyncRoom } from '@/components';
import { inject, observer } from 'mobx-react';
import { DeviceStoreTypes } from '@/stores/device';
import { useEffectOnce, useLocalStorage } from 'react-use';
import useReactRouter from 'use-react-router';
import Encryption from '@/utils/Encryption';
import * as R from 'ramda';
import log from '@/utils/log'

export interface SynchronizationProps {
    DeviceStore: DeviceStoreTypes;
}

const Synchronization: React.FC<SynchronizationProps> = inject('DeviceStore')(observer(props => {

    const { DeviceSyncStore } = props.DeviceStore;
    const [userInfo]: any = useLocalStorage('userInfo');
    const { token } = userInfo;
    const decodeInfo = JSON.parse(Encryption.decayFun(token, 'NgAbCJJGfUlQ6653'));
    //获取rotate和size
    const getQueryVariable = (variable: string) => {
        let query = window.location.search.substring(1);
        let vars = query.split("&");
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split("=");
            if (pair[0] === variable) { return pair[1]; }
        }
        return (false);
    }
    const initCloud = () => {
        const { accessKeyId, masterId, slaveIds, packageName, cap, token } = DeviceSyncStore;

        DeviceSyncStore.cloudPlay = new (window as any).Cloudplay({
            accessKeyId,
            masterId,
            slaveIds,
            packageName,
            cap,
            token,
            userInfo: {
                userId: decodeInfo.uid,
                userToken: decodeInfo.token
            },
            onSceneChanged: onSceneChanged
        });
    }
    useEffectOnce(() => {
        (async () => {
            log({ pageId: 'P25', eventId: 'E2500', ext: '' })
            //大小视图&&横竖屏
            const sizeType = getQueryVariable('size');
            const rotateType = getQueryVariable('rotate');
            sizeType ? DeviceSyncStore.setSizeType(sizeType) : DeviceSyncStore.setSizeType('medium');
            rotateType ? DeviceSyncStore.setRotateType(rotateType) : DeviceSyncStore.setRotateType('vertical');

            //模拟请求云机同步数据(第一步)
            await DeviceSyncStore.getDeviceSyncStore()
            //列表请求完成播流(第二步)
            initCloud()

            //点击页面取消自定义下来
            document.addEventListener('click', () => {
                DeviceSyncStore.totalCheckedIndex = 999
            });
        })()
    })

    //退出同步
    const { history } = useReactRouter();
    const backHomePage = () => {
        log({ pageId: 'P25', eventId: 'E2502', ext: '' })
        history.push('/Home/CloudPhone');
    }
    //播流回调
    const onSceneChanged = (start: any, stop: any) => {
        console.log(start, stop)
    }

    const backspace = (id: string) => {
        DeviceSyncStore.cloudPlay.backspace(id)
    }
    const home = (id: string) => {
        DeviceSyncStore.cloudPlay.home(id)
    }
    const menu = (id: string) => {
        DeviceSyncStore.cloudPlay.menu(id)
    }
    const volumeUp = (id: string) => {
        log({ pageId: 'P25', eventId: 'E2505', ext: '' })
        DeviceSyncStore.cloudPlay.volumeUp(id);
    }
    const volumeDown = (id: string) => {
        log({ pageId: 'P25', eventId: 'E2505', ext: '' })
        DeviceSyncStore.cloudPlay.volumeDown(id);
    }
    const changeMain = (id: string) => {
        log({ pageId: 'P25', eventId: 'E2501', ext: '' })
        let deviceList = JSON.parse(window.localStorage.getItem('deviceList') || '{}');

        const index = R.findIndex(R.propEq('cid', id))(deviceList)
        deviceList = R.move(index, 0, deviceList)
        props.DeviceStore.DeviceBaseStore.setCids(R.move(index, 0, props.DeviceStore.DeviceBaseStore.selectedCids))
        
        window.localStorage.setItem('deviceList',JSON.stringify(deviceList))
        DeviceSyncStore.getDeviceSyncStore();
        initCloud();
        setTimeout(function () {
            window.location.reload();
        }, 0)
    }
    const totalCheckedIndexChange = (e: any, index: number) => {
        e.nativeEvent.stopImmediatePropagation();
        DeviceSyncStore.totalCheckedIndex = index;
    }
    const soundTypeChange = () => {
        DeviceSyncStore.soundType = DeviceSyncStore.soundType === 'show' ? 'hidden' : 'show';
    }
    const sizeTypeChange = (type: string) => {
        log({ pageId: 'P25', eventId: 'E2503', ext: '' })
        history.push(`/Synchronization?rotate=${DeviceSyncStore.rotateType}&size=${type}`)
        window.location.reload();
    }
    const rotateTypeChange = () => {
        log({ pageId: 'P25', eventId: 'E2504', ext: '' })
        DeviceSyncStore.rotateType === 'vertical' ? DeviceSyncStore.setRotateType('across') : DeviceSyncStore.setRotateType('vertical')
        history.push(`/Synchronization?rotate=${DeviceSyncStore.rotateType}&size=${DeviceSyncStore.sizeType}`)
        window.location.reload();
    }
    return (
        <>
            <SyncRoom.Head onChange={backHomePage} />
            <SyncRoom.List
                actions={{
                    backspace: backspace,
                    home: home,
                    menu: menu,
                    volumeUp: volumeUp,
                    volumeDown: volumeDown,
                    changeMain: changeMain
                }}
                slaveIds={DeviceSyncStore.slaveIds}
                masterId={DeviceSyncStore.masterId}
                masterName={DeviceSyncStore.masterName}
                soundType={DeviceSyncStore.soundType}
                soundTypeChange={soundTypeChange}

                sizeType={DeviceSyncStore.sizeType}
                sizeTypeChange={sizeTypeChange}

                rotateType={DeviceSyncStore.rotateType}
                rotateTypeChange={rotateTypeChange}

                totalCheckedIndex={DeviceSyncStore.totalCheckedIndex}
                totalCheckedIndexChange={totalCheckedIndexChange}

            />
        </>
    )
}))

export default Synchronization;
